import { Resources } from 'constants/resources';

import Skeleton from '@mui/material/Skeleton';
import { usePermissions } from 'hooks/usePermissions';
import { Divider } from 'shared/mui/Divider/Divider';
import { Permission } from 'types/embedded/permission';

import {
  GatewayRuleCardHeaderActionsStyled,
  GatewayRuleCardHeaderContentStyled,
  GatewayRuleCardHeaderStyled,
  GatewayRuleCardStyled,
} from './GatewayRuleCard/GatewayRuleCard.styled';
import {
  GatewayRuleInfoFieldsStyled,
  GatewayRuleInfoNameStyled,
  GatewayRuleInfoWrapperStyled,
} from './GatewayRuleInfo.styled';

export const GatewayRulesDatagridSkeleton: React.FC = () => {
  const { hasResourcePermissions } = usePermissions();

  return (
    <>
      {Array.from({ length: 5 }).map((_, index) => (
        <GatewayRuleCardStyled key={index} sx={{ opacity: 1 / (index + 1) }}>
          <GatewayRuleCardHeaderStyled>
            {hasResourcePermissions(Resources.GatewayRules, [
              Permission.Full,
              Permission.Update,
            ]) && (
              <Skeleton
                height={20}
                sx={{ flexShrink: 0, margin: '9px 28px 9px 12px' }}
                variant="rounded"
                width={34}
              />
            )}
            <GatewayRuleCardHeaderContentStyled>
              <GatewayRuleInfoWrapperStyled>
                <GatewayRuleInfoNameStyled>
                  <Skeleton height={20} variant="text" width={240} />
                </GatewayRuleInfoNameStyled>
                <GatewayRuleInfoFieldsStyled>
                  <Skeleton height={24} variant="text" width={64} />
                  <Skeleton height={24} variant="text" width={160} />
                  <Skeleton height={24} variant="text" width={200} />
                  <Skeleton height={24} variant="text" width={200} />
                </GatewayRuleInfoFieldsStyled>
              </GatewayRuleInfoWrapperStyled>
              <GatewayRuleCardHeaderActionsStyled>
                <Skeleton height={28} variant="circular" width={28} />
                <Divider flexItem orientation="vertical" sx={{ marginX: 2 }} />
                <Skeleton height={34} variant="circular" width={34} />
              </GatewayRuleCardHeaderActionsStyled>
            </GatewayRuleCardHeaderContentStyled>
          </GatewayRuleCardHeaderStyled>
        </GatewayRuleCardStyled>
      ))}
    </>
  );
};
